import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LogoFellowIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "LogoFellow",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M9.82 18.549a6.7 6.7 0 0 1-.5-2.55c0-1.761.68-3.454 1.9-4.724a6.58 6.58 0 0 1 4.607-2.02 16.8 16.8 0 0 1 2.003-5.21 11.64 11.64 0 0 0-6.5.753 11.8 11.8 0 0 0-3.85 2.63 12.1 12.1 0 0 0-2.561 3.936A12.2 12.2 0 0 0 4.04 16a12.4 12.4 0 0 0 1.047 5.007c1.53-.91 3.11-1.73 4.731-2.457M14.821 18.126a.76.76 0 0 0-1.002-.204C11.447 19.329 3.451 24.04.991 28.627c-2.077 3.9 2.28 3.57 4.778 3.095a6.87 6.87 0 0 0 3.003-1.382 15.6 15.6 0 0 0 4.374-5.124 15.86 15.86 0 0 0 1.83-6.53.85.85 0 0 0-.155-.56"
    }), /*#__PURE__*/_jsx("ellipse", {
      cx: "15.907",
      cy: "15.979",
      rx: "1.502",
      ry: "1.53"
    }), /*#__PURE__*/_jsx("path", {
      d: "M21.971 13.437a6.79 6.79 0 0 1-.518 6.152 6.6 6.6 0 0 1-2.253 2.2 6.46 6.46 0 0 1-2.997.89 16 16 0 0 1-1.868 5.286q.77.102 1.547.102c1.562.01 3.11-.294 4.552-.896a11.8 11.8 0 0 0 3.86-2.612 12.05 12.05 0 0 0 2.575-3.926c.595-1.47.897-3.044.89-4.633 0-1.786-.387-3.551-1.132-5.169a55 55 0 0 1-4.656 2.606M26.236.278a6.95 6.95 0 0 0-3.004 1.387C20.924 3.5 17.299 6.9 16.842 13.263c-.017.2.035.4.147.566a.76.76 0 0 0 1 .21c2.374-1.413 10.56-6.047 13.019-10.667 2.078-3.9-2.273-3.568-4.772-3.094"
    })]
  }));
};
LogoFellowIcon.displayName = 'LogoFellowIcon';